module.exports = __webpack_public_path__ + "static/media/camera.14ddc464.png";